<template>
  <div class="zcbody" v-loading="loading">
    <div class="zc-header">
      <div class="head" style="padding: 20px 0 30px 0;">
        <div class="logo">
          <router-link :to="{path:'/login'}"><img src="../../assets/images/logo.png" style="width:80px" /></router-link>
        </div>
        <span class="logintext">认养一头牛SRM供应商管理平台</span>
      </div>
    </div>
    <div class="contaner">
      <div class="z_heng">
        <ul>
          <li class="agreement active">
            <img src="../../assets/images/agreement2.png" /><span>注册协议</span>
          </li>
          <li class="information active">
            <img src="../../assets/images/information3.png" /><span>用户信息</span>
          </li>
          <li class="archives active">
            <img src="../../assets/images/archives4.png" /><span>供货信息</span>
          </li>
          <li class="supply-object active">
            <img src="../../assets/images/supply-object4.png" /><span>上传资质</span>
          </li>
          <li class="intelligence">
            <img src="../../assets/images/intelligence1.png" /><span>注册完成</span>
          </li>
        </ul>
      </div>
      <div class="protocol-title">上传资质文件</div>
      <div class="protocont">
        <span style="color: red" class="prospan">红色字体为必填项，资质上传日期、资质失效日期以及扫描件不能为空</span>

        <el-table ref="multipleTable" :data="tableall" border max-height="560" tooltip-effect="dark" v-if="tableif"
          style="width: 100%" :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }">
          <el-table-column label="资质名称" width="120" :render-header="renderHeader">
            <template slot-scope="scope">
              <font style="color: red" v-if="scope.row.cisupload=='1' ">{{ scope.row.cfilename }}</font>
              <font style="color: #333" v-else>{{ scope.row.cfilename }}</font>
            </template>
          </el-table-column>
          <el-table-column label="资质编号" prop="cfilecode" width="90" :render-header="renderHeader"></el-table-column>
          <el-table-column label="上传时间" width="100" prop="dfileuplodtime">
          </el-table-column>
          <el-table-column label="资质生效时间" width="120" prop="dfilestarttime"></el-table-column>
          <el-table-column label="资质失效时间" width="120" prop="dfileendtime"></el-table-column>
          <!-- <el-table-column
            label="文件路径"
            prop="cdemopath"
            :render-header="renderHeader"
          ></el-table-column> -->
          <el-table-column label="备注" prop="cremakspaper"></el-table-column>
          <el-table-column prop="name" label="操作" width="260">
            <template slot-scope="scope">
              <el-button size="mini" @click="regit(scope.row, scope.$index)">添加修改</el-button>
              <el-button size="mini" @click="read(scope.row, scope.$index)" plain
                v-if="scope.row.cdemopath!=''">查看</el-button>
              <el-button size="mini" type="success" @click="down(scope.row, scope.$index)" v-if="scope.row.cfileurl!=''"
                plain>下载</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="prompt-text">
          请上传资质文件原件的扫描件，<span style="color:red">选择类型为PDF文件或者图片</span>，请彩色扫描并上传。要求:
          所有文档均需贵公司签字、盖章（2页的需要盖骑缝章）、标明时间。
        </div>
        <div class="zc_btn">
          <el-button type="success" round @click="prereturn()">上一步</el-button>
          <el-button type="success" round @click="clickSubmit()">注册</el-button>
        </div>
      </div>
      <el-dialog :visible.sync="dialogFormVisible" :append-to-body="true" customClass="way assoform">
        <el-form ref="assoruleForm" :rules="assorules" :model="qualiform" label-width="85px" class="form01"
          v-if="qualiform.cisupload == '1' ">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="生效日期:" prop="dfilestarttime">
                <el-date-picker v-model="qualiform.dfilestarttime" type="date" placeholder="选择日期" key="c"
                  value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="失效日期:" prop="dfileendtime">
                <el-date-picker v-model="qualiform.dfileendtime" type="date" placeholder="选择日期" key="d"
                  value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="24">

              <el-form-item label="备注:" label-width="100%" style="margin-bottom: 0;" maxlength="200" class="itemcenter">
              </el-form-item>
              <el-form-item prop="cremakspaper" label-width="0">
                <el-input type="textarea" v-model="qualiform.cremakspaper" placeholder="请输入备注" rows="4"
                  style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="cdemopath" label="证书:" class="crem">
                <el-upload action="#" ref="uploadFail" :show-file-list="false" accept=".pdf,.png,.jpg,.jpeg"
                  :before-upload="brforeUploadreImportFail" :auto-upload="false" :on-change="handleChangeFail"
                  :file-list="fileListFail">
                  <el-button type="success" size="mini">上传证书</el-button>
                  <!-- <div slot="tip" class="el-upload__tip">
                  只能上传.pdf/.PDF文件
                </div> -->
                  <div slot="tip" class="el-upload__tip" style="color:green">证书名称:{{ Cname }}</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-form ref="assoruleForm" :model="qualiform" label-width="85px" class="form01" v-else>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="生效日期:" prop="dfilestarttime">
                <el-date-picker v-model="qualiform.dfilestarttime" type="date" placeholder="选择日期" key="c"
                  value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="失效日期:" prop="dfileendtime">
                <el-date-picker v-model="qualiform.dfileendtime" type="date" placeholder="选择日期" key="d"
                  value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="24">

              <el-form-item label="备注:" label-width="100%" style="margin-bottom: 0;" maxlength="200" class="itemcenter">
              </el-form-item>
              <el-form-item prop="cremakspaper" label-width="0">
                <el-input type="textarea" v-model="qualiform.cremakspaper" placeholder="请输入备注" rows="4"
                  style="width: 100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="cdemopath" label="证书:" class="crem">
                <el-upload action="#" ref="uploadFail" :show-file-list="false" :before-upload="brforeUploadreImportFail"
                  :auto-upload="false" :on-change="handleChangeFail" :file-list="fileListFail">
                  <el-button type="success" size="mini">上传证书</el-button>
                  <!-- <div slot="tip" class="el-upload__tip">
                  只能上传.pdf/.PDF文件
                </div> -->
                  <div slot="tip" class="el-upload__tip">证书名称:{{ Cname }}</div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closesad()">取 消</el-button>
          <el-button type="success" @click="confirm('assoruleForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        qualiform: {
          dfilestarttime: "",
          dfileendtime: "",
          cremakspaper: "",
          cdemopath: "",
        },
        loading: false,
        urlid: "",
        tableall: [],
        dialogFormVisible: false,
        tableif: true,
        fileListFail: [],
        assorules: {
          cdemopath: [{ required: true, message: "请上传文件", trigger: "blur" }],
          dfilestarttime: [
            { required: true, message: "请资质生效日期", trigger: "blur" },
          ],
          dfileendtime: [
            { required: true, message: "请资质失效日期", trigger: "blur" },
          ],
        },
        Cname: "",
      };
    },
    created() {
      this.urlid = this.$route.query.id;
      this.getTableData();
    },
    methods: {
      // 获取基本信息
      getTableData() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetCustomerFile",
          data: { KeyValue: this.urlid },
        }).then((res) => {
          console.log(res, "urlid");
          if (res.data.Success) {
            if (res.data.Data != "") {
              this.tableall = res.data.Data;
            }
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 查看
      read(row, index) {
        let routeUrl = this.global.BASE_URL + row.cdemopath;
        window.open(routeUrl);
      },
      down(row, afff) {
        console.log(row.cfileurl);
        // 下载文件
        //  let routeUrl = row.cfileurl;
        // window.open(routeUrl);
        const a = document.createElement("a");
        let urlblob = this.global.bxiosdow + row.cfileurl;
        fetch(urlblob)
          .then((res) => res.blob())
          .then((blob) => {
            // 将链接地址字符内容转变成blob地址
            a.href = URL.createObjectURL(blob);
            console.log(a.href);
            a.download = ""; // 下载文件的名字
            document.body.appendChild(a);
            a.click();
          });
      },
      //上传文件
      handleChangeFail(file, fileList) {
        this.$refs.uploadFail.submit();
      },

      brforeUploadreImportFail(file) {
        this.loading = true;
        let params = new FormData();
        params.append("KeyValue", this.urlid);
        params.append("file", file);
        params.append("file", URL.createObjectURL(file));
        params.append("dindex", this.qualiform.dindex);
        console.log(file, "开始上传");

        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/SaveCusPaper",
          headers: { "Content-Type": "multipart/form-data" },
          data: params,
          timeout: 30000000,
        }).then((res) => {
          console.log(res, "上传结果");
          this.loading = false;
          if (res.data.Success) {
            this.$message({
              howClose: true,
              message: "上传成功",
              type: "success",
            });

            this.qualiform.cdemopath = res.data.Data.Path;
            this.Cname = res.data.Data.Cname;
            this.qualiform.dfileuplodtime = res.data.Data.CreateTime;
          } else {
            this.Cname = res.data.Message;
          }
        });

        return false; //屏蔽了action的默认上传
      },
      closesad() {
        (this.qualiform = {
          dfilestarttime: "",
          dfileendtime: "",
          cremakspaper: "",
          cdemopath: "",
        }),
          (this.Cname = "");
        this.dialogFormVisible = false;
      },
      confirm(assoruleForm) {
        this.$refs[assoruleForm].validate((valid) => {
          if (valid) {
            this.tableif = false;
            console.log(this.qualiform);
            for (var a = 0; a < this.tableall.length; a++) {
              if (this.qualiform.cfilecode == this.tableall[a].cfilecode) {
                this.tableall[a] = this.qualiform;
              }
            }
            setTimeout(() => {
              this.tableif = true;
            }, 3);

            console.log(this.tableall);
            this.Cname = "";
            this.dialogFormVisible = false;
          } else {
            this.$message.error("请填写完整信息");
            return false;
          }
        });
      },
      // 添加和修改
      regit(row, index) {
        this.qualiform = JSON.parse(JSON.stringify(row));
        this.Cname = this.qualiform.cdemopath.split("/")[3];
        this.dialogFormVisible = true;
        setTimeout(() => {
          this.$refs.assoruleForm.resetFields();
          console.log(this.$refs.assoruleForm);
        }, 100);

        console.log(this.Cname);
      },
      renderHeader(h, { column }) {
        return h("div", [
          h(
            "font",
            {
              style: "color:red;margin-right:5px;",
            },
            "*"
          ),
          h(
            "span",
            {
              style: "color:#046dbe;",
            },
            column.label
          ),
        ]);
      },

      // 返回上一步
      prereturn() {
        this.$router.push({ path: "/SupplyObject", query: { id: this.urlid } });
      },
      clickSubmit() {
        var ddd = this.tableall;
        var newdata = [];
        var wanzheng = true;
        for (var i = 0; i < ddd.length; i++) {
          if (ddd[i].cisupload == "1") {
            if (ddd[i].cdemopath == "") {
              this.$message.error(
                "红色字体为必填项，资质上传日期、资质失效日期以及扫描件不能为空"
              );
              return false;
            }
          }
          // if (ddd[i].cdemopath == "") {
          //   //判断前五条图片地址是否为空
          //   this.$message.error("信息不完整！");
          //   wanzheng = false;
          //   return;
          // } else
          if (ddd[i].cfilecode == "") {
            //判断前五条图片地址是否为空
            this.$message.error("资质编号为空！");
            wanzheng = false;
            return false;
          } else {
            wanzheng = true;
            newdata.push({
              cfilecode: ddd[i].cfilecode,
              dfileuplodtime: ddd[i].dfileuplodtime,
              dfilestarttime: ddd[i].dfilestarttime,
              dfileendtime: ddd[i].dfileendtime,
              cremakspaper: ddd[i].cremakspaper,
              cdemopath: ddd[i].cdemopath,
              cfilename: ddd[i].cfilename,
              dindex: ddd[i].dindex,
            });
          }
        }
        if ((wanzheng = true)) {
          this.$confirm(
            "请确认注册信息,点注册提交后在完成审批结束前将无法修改，您确认要提交该申请吗？",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              this.$axios({
                method: "post",
                url: "CommonModule/Op_Supplier/SaveCusPaperInfo",
                data: {
                  jsonDetail: JSON.stringify(newdata),
                  KeyValue: this.urlid,
                  cstep: 5,
                },
              }).then((res) => {
                console.log(res, "urlid");
                if (res.data.Success) {
                  this.sumbit();
                } else {
                  this.$message.error(res.data.Message);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消删除",
              });
            });
        }
      },
      sumbit() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/Submit",
          data: { KeyValue: this.urlid },
        }).then((res) => {
          console.log(res, "urlid");
          if (res.data.Success) {
            this.$message.success(res.data.Message);
            this.$router.push({ path: "/dlxxEnd", query: { id: this.urlid } });
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
    },

    mounted() { },
  };
</script>
<style scoped>
  @import url(../../assets/css/reg.css);

  .crem>>>.el-form-item__label {
    background: none;
    border: 0;
  }
</style>